import { useState } from "react";
import { Accordion } from "react-bootstrap";
import classes from "./helpCenter.module.scss";
import { useToasts } from "react-toast-notifications";
import { useDispatch } from "react-redux";

//icons
import { ReactComponent as CloseIcon } from "@/assets/images/icons/Updates/close-icon.svg";
import { ReactComponent as EditIcon } from "@/assets/images/icons/Maintainers/edit.svg";
import { ReactComponent as AddIcon } from "@/assets/images/icons/Maintainers/plus-solid.svg";
//Components
import BasicConfirm from "@/components/Confirm/BasicConfirm";
import CategoryEditForm from "./CategoryEditForm";
import QuestionForm from "./QuestionForm";
//Services
import api from "@/services/api.service";

import { DELETE_HELP_CENTER_SUCCESS } from "@/redux/types/help_center.types";
import QuestionView from "./QuestionView";
import QuestionEditForm from "./QuestionEditForm";
const CategoryAccordion = ({ item }) => {
	const dispatch = useDispatch();
	const { addToast } = useToasts();
	const [showCategoryConfirm, setShowCategoryConfirm] = useState(false);
	const [showQuestionConfirm, setShowQuestionConfirm] = useState(false);
	const [deleteId, setDeleteId] = useState(null);
	const [editForm, setEditForm] = useState(false);
	const [questionEditForm, setQuestionEditForm] = useState(false);
	const [addForm, setAddForm] = useState(false);
	const [view, setView] = useState(false);
	const [data, setData] = useState({});
	const [editData, setEditData] = useState({});

	const confirmDeleteCategory = () => {
		setShowCategoryConfirm(true);
	};
	const handleCategoryClose = () => {
		setShowCategoryConfirm(false);
	};
	const confirmDeleteQuestion = (id) => {
		setDeleteId(id);
		setShowQuestionConfirm(true);
	};
	const confirmQuestionClose = () => {
		setShowQuestionConfirm(false);
	};
	const handleEdit = () => {
		setEditForm(true);
	};
	const handleEditClose = () => {
		setEditForm(false);
	};
	const editQuestion = (data) => {
		setEditData(data);
		setQuestionEditForm(true);
	};
	const editCloseQuestion = () => {
		setQuestionEditForm(false);
	};
	const handleAddModal = () => {
		setAddForm(true);
	};
	const handleCloseAddModal = () => {
		setAddForm(false);
	};
	const viewModal = (data) => {
		setData(data);
		setView(true);
	};
	const closeViewModal = () => {
		setView(false);
	};
	const handleQuestionDelete = () => {
		const params = {
			post_id: deleteId,
		};
		api.post("/admin/delete_question", params).then((response) => {
			addToast(response.message, {
				appearance: "success",
			});
			dispatch({
				type: DELETE_HELP_CENTER_SUCCESS,
				payload: {
					questions: response.data.questions.data,
				},
			});

			confirmQuestionClose();
		});
	};
	const handleDelete = () => {
		const params = {
			post_id: item.post_id,
		};
		api.post("/admin/delete_category", params).then((response) => {
			if (response.status === "success") {
				addToast(response.message, {
					appearance: "success",
				});
				dispatch({
					type: DELETE_HELP_CENTER_SUCCESS,
					payload: {
						questions: response.data.questions.data,
					},
				});
			} else {
				addToast(response.response.data.message, {
					appearance: "error",
				});
			}
			handleCategoryClose();
		});
	};

	return (
		<Accordion className={`${classes.accordion}`}>
			<Accordion.Item eventKey={item.post_id}>
				<div className={`${classes.accordion_header}`}>
					<Accordion.Button as="div">
						<h5>{item.title} </h5>
						<p>{item.description}</p>
					</Accordion.Button>

					<div className={`${classes.option_container}`}>
						<EditIcon
							className={`${classes.edit_icon}`}
							onClick={(e) => {
								e.stopPropagation();
								handleEdit(item.post_id);
							}}
						/>
						<CloseIcon
							className={`${classes.close_icon}`}
							onClick={(e) => {
								e.stopPropagation();
								confirmDeleteCategory(item.post_id);
							}}
						/>
					</div>
				</div>

				<Accordion.Body>
					<div className={`${classes.question_list}`}>
						<button onClick={handleAddModal}>
							{" "}
							Agregar pregunta <AddIcon className={`${classes.add_icon}`} />
						</button>

						{item.post_details &&
							item.post_details.map((question, index) => (
								<li key={index}>
									<p onClick={() => viewModal(question)}>{question.title}</p>
									<div className={`${classes.option_question_container}`}>
										<EditIcon className={`${classes.edit_icon_question}`} onClick={() => editQuestion(question)} />
										<CloseIcon className={`${classes.close_icon_question}`} onClick={() => confirmDeleteQuestion(question.id)} />
									</div>
								</li>
							))}
					</div>
				</Accordion.Body>
			</Accordion.Item>
			<BasicConfirm
				showConfirm={showCategoryConfirm}
				setShowConfirm={setShowCategoryConfirm}
				message={`¿Estas seguro de eliminar esta categoría?`}
				handleAction={handleDelete}
			/>
			<BasicConfirm
				showConfirm={showQuestionConfirm}
				setShowConfirm={setShowQuestionConfirm}
				message={`¿Estas seguro de eliminar esta pregunta?`}
				handleAction={handleQuestionDelete}
			/>
			<CategoryEditForm
				title={item.title}
				description={item.description}
				post_id={item.post_id}
				show={editForm}
				onHide={handleEditClose}
				handleEditClose={handleEditClose}
			/>

			<QuestionForm post_id={item.post_id} show={addForm} onHide={handleCloseAddModal} handleCloseAddModal={handleCloseAddModal} />
			<QuestionView show={view} data={data} onHide={closeViewModal} closeViewModal={closeViewModal} />
			<QuestionEditForm
				editData={editData}
				setEditData={setEditData}
				show={questionEditForm}
				onHide={editCloseQuestion}
				editCloseQuestion={editCloseQuestion}
			/>
		</Accordion>
	);
};

export default CategoryAccordion;
